// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17fDu","largestCol":"styles_largestCol__3WidM","smallestCol":"styles_smallestCol__kXTCw"};